import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, DoCheck, EventEmitter,
  Input, OnChanges, OnInit, Output, SimpleChanges
} from '@angular/core';



@Component({
  selector: 'pgs-paginator',
  templateUrl: './pgs-paginator.component.html',
  styleUrls: ['./pgs-paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PgsPaginatorComponent implements OnChanges, OnInit, DoCheck {

  @Input() public readonly length: number;
  @Input() public isTable: boolean;

  @Output() public changePageEmitter: EventEmitter<number>;
  @Output() public changeTotalToShowEmitter: EventEmitter<number>;

  public pages: number[];
  public pagesPaginate: number[];
  public totalToShow: number;

  private activePage: number;
  

  constructor(
    private readonly changeDetector: ChangeDetectorRef
  ) {
    this.length = 0;
    this.changePageEmitter = new EventEmitter();
    this.changePageEmitter.emit(this.currentPage);
    this.totalToShow = 5;
    this.changeTotalToShowEmitter = new EventEmitter();
    this.pages = [ ];
    this.pagesPaginate = [ ];
    this.activePage = 1;
    this.isTable = true;
  }
  

  ngOnChanges(changes: SimpleChanges): void {
    const { firstChange, previousValue, currentValue } = changes.length;

    console.log({ changes });

    if (!firstChange && previousValue !== currentValue) {
      this.pages = Array(this.roundUp(this.length / this.totalToShow)).fill(0).map((x, i) => i + 1);
      this.pages.length === 1 && this.toFirst();
      this.pages.length < this.currentPage && this.toLast();
    }
  }

  
  ngOnInit(): void {
    this.initPages();
  }
  

  ngDoCheck(): void {
    const [ subtraction, addition ] = this.activePage === this.pages.length ? [5, 0] : this.activePage === this.pages.length - 3 ? [2, 4]
          : [(this.activePage === this.pages.length - 1) ? 4 : 3, (this.activePage === this.pages.length - 2) ? 3 : 2];

    this.pagesPaginate =
      this.activePage >= 5 ? this.pages.slice(this.activePage - subtraction, this.activePage + addition) : this.pages.slice(0, 5);
    this.changePageEmitter.emit(this.currentPage);

    this.changeDetector.detectChanges();
  }
  
  private initPages(): void {
    this.pages = Array(this.roundUp(this.length / this.totalToShow)).fill(0).map((x, i) => i + 1);
  }
  

  public toPrevious(): void {
    if (this.activePage > 1) {
      this.activePage -= 1;
      this.changeDetector.detectChanges();
    }
  }

  
  public toFirst(): void {
    this.activePage = 1;
    this.changeDetector.detectChanges();
  }

  
  public onClick(pageSelected: number): void {
    this.activePage = pageSelected;
    this.changeDetector.detectChanges();
  }

  
  public toLast(): void {
    this.activePage = this.pages.length;
    this.changeDetector.detectChanges();
  }

  
  public toNext(): void {
    if (this.activePage < this.pages.length) {
      this.activePage += 1;
      this.changeDetector.detectChanges();
    }
  }
  

  public roundUp(value: number): number {
    return Math.ceil(value);
  }
  
  
  public changeTotalToShow(total: number): void {
    this.totalToShow = total;
    this.initPages();
    this.currentPage > this.pages.length && this.toLast();
    this.changeTotalToShowEmitter.emit(this.totalToShow);
  }
  

  get currentPage(): number {
    return this.activePage;
  }
}
